/* eslint-disable sort-keys-fix/sort-keys-fix */

import { useMediaProps } from '@zapier/responsive-utils';

export const sizes = {
  desktop: 1200,
  desktopLarge: 1800,
  phone: 599,
  tabletLandscape: 900,
  tabletPortrait: 600,
};

export const queries = {
  desktop: `(min-width: 1024px)`,
  desktopLargePlus: `(min-width: ${sizes.desktopLarge}px)`,
  desktopPlus: `(min-width: ${sizes.desktop}px)`,
  phablet: `(min-width: 420px) and (max-width: 659px)`,
  phone: `(min-width: 0) and (max-width: 419px)`,
  phoneOnly: `(max-width: ${sizes.phone}px)`,
  tablet: `(min-width: 660px) and (max-width: 1023px)`,
  tabletLandscapePlus: `(min-width: ${sizes.tabletLandscape}px)`,
  tabletPortraitPlus: `(min-width: ${sizes.tabletPortrait}px)`,
};

export const supports = {
  // Yes, this media query is counter-intuitive
  // Source: https://stackoverflow.com/a/42363147
  hover: '@media not all and (hover: none)',
};

export const Screen = {
  queries,
  sizes,
  supports,
};

export const useSize = () => {
  const mediaProps = useMediaProps({
    all: {
      size: 'small',
    },
    [Screen.queries.tablet]: {
      size: 'medium',
    },
    [Screen.queries.desktop]: {
      size: 'large',
    },
  });

  return mediaProps?.size;
};
